// extracted by mini-css-extract-plugin
export default {"dashboard_container":"CampaignDashboard_dashboard_container__Oi-EN"};